import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { CUSTOM_EMOJI_METADATA, STANDARD_EMOJI_CATEGORIES } from './emojiData';
export default class EmojiPicker extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isOpen", false);
    _defineProperty(this, "activeTab", 'athletic');
    _defineProperty(this, "searchQuery", '');
    _defineProperty(this, "hoveredLabel", '');
    _defineProperty(this, "recentEmojis", []);
    _defineProperty(this, "closeHandler", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadRecents();
  }
  loadRecents() {
    try {
      const raw = localStorage.getItem('aurrera_recent_emojis');
      this.recentEmojis = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(this.recentEmojis)) {
        this.recentEmojis = [];
      }
    } catch (_unused) {
      this.recentEmojis = [];
    }
  }
  saveRecent(item) {
    try {
      this.recentEmojis = [item, ...this.recentEmojis.filter(r => r.value !== item.value)].slice(0, 24);
      localStorage.setItem('aurrera_recent_emojis', JSON.stringify(this.recentEmojis));
    } catch (_unused2) {
      // Storage quota or privacy mode error ignored
    }
  }
  view() {
    const baseUrl = app.forum.attribute('baseUrl').replace(/\/$/, '');
    const customEmojis = app.data.customEmojis || {};
    const customNames = Object.keys(customEmojis);
    const filtered = this.getFilteredEmojis(customNames);
    return m("div", {
      className: "EmojiPicker-wrapper ".concat(this.isOpen ? 'open' : '')
    }, m("button", {
      className: "Button Button--link EmojiPicker-trigger ".concat(this.isOpen ? 'active' : ''),
      type: "button",
      onclick: e => {
        e.stopPropagation();
        this.toggle();
      },
      title: "Emojis y Stickers",
      "aria-label": "Abrir selector de emojis y stickers"
    }, m("i", {
      className: "fas fa-smile icon"
    })), this.isOpen && m("div", {
      className: "EmojiPicker-menu",
      onclick: e => e.stopPropagation()
    }, m("div", {
      className: "EmojiPicker-header"
    }, m("div", {
      className: "EmojiPicker-search"
    }, m("i", {
      className: "fas fa-search EmojiPicker-searchIcon"
    }), m("input", {
      type: "text",
      className: "FormControl EmojiPicker-searchInput",
      placeholder: "Buscar emoji... (ej. le\xF3n, risa, copa, birra)",
      value: this.searchQuery,
      oninput: e => {
        this.searchQuery = e.target.value;
      },
      onkeydown: e => {
        if (e.key === 'Escape') {
          if (this.searchQuery) {
            this.searchQuery = '';
            e.stopPropagation();
          } else {
            this.toggle();
          }
        }
      }
    }), this.searchQuery && m("button", {
      type: "button",
      className: "EmojiPicker-searchClear",
      onclick: () => {
        this.searchQuery = '';
      },
      title: "Limpiar b\xFAsqueda"
    }, m("i", {
      className: "fas fa-times"
    })))), !this.searchQuery && m("div", {
      className: "EmojiPicker-tabs"
    }, m("button", {
      type: "button",
      className: "EmojiPicker-tab ".concat(this.activeTab === 'athletic' ? 'active' : ''),
      onclick: () => {
        this.activeTab = 'athletic';
      },
      title: "Stickers Athletic Club"
    }, "\uD83E\uDD81"), this.recentEmojis.length > 0 && m("button", {
      type: "button",
      className: "EmojiPicker-tab ".concat(this.activeTab === 'recent' ? 'active' : ''),
      onclick: () => {
        this.activeTab = 'recent';
      },
      title: "Recientes"
    }, "\uD83D\uDD52"), STANDARD_EMOJI_CATEGORIES.map(category => {
      var _category$emojis$;
      return m("button", {
        type: "button",
        className: "EmojiPicker-tab ".concat(this.activeTab === category.id ? 'active' : ''),
        onclick: () => {
          this.activeTab = category.id;
        },
        title: category.name
      }, ((_category$emojis$ = category.emojis[0]) == null ? void 0 : _category$emojis$.char) || '⭐');
    })), filtered ? this.renderSearchResults(filtered, baseUrl) : this.renderActiveTab(customNames, baseUrl), m("div", {
      className: "EmojiPicker-footer"
    }, m("span", {
      className: "EmojiPicker-previewLabel"
    }, this.hoveredLabel || (this.searchQuery ? 'Haz clic para insertar' : 'Elige un emoji o sticker')))));
  }
  renderActiveTab(customNames, baseUrl) {
    if (this.activeTab === 'athletic') {
      if (customNames.length === 0) {
        return m("div", {
          className: "EmojiPicker-body EmojiPicker-empty"
        }, m("p", null, "No hay stickers disponibles."));
      }
      return m("div", {
        className: "EmojiPicker-body EmojiPicker-grid EmojiPicker-grid--custom"
      }, customNames.map(name => {
        const meta = CUSTOM_EMOJI_METADATA[name] || {
          label: name.replace(/^ee-/, '').replace(/-/g, ' ')
        };
        return m("button", {
          className: "EmojiPicker-item EmojiPicker-item--custom",
          type: "button",
          title: ":".concat(name, ":"),
          "data-emoji": name,
          "aria-label": meta.label,
          onmouseenter: () => {
            this.hoveredLabel = meta.label;
          },
          onmouseleave: () => {
            this.hoveredLabel = '';
          },
          onclick: e => {
            e.stopPropagation();
            this.insert('custom', name, meta.label);
          }
        }, m("img", {
          src: "".concat(baseUrl, "/api/custom-emojis/").concat(name),
          alt: meta.label,
          className: "EmojiPicker-img",
          loading: "lazy"
        }));
      }));
    }
    if (this.activeTab === 'recent') {
      if (this.recentEmojis.length === 0) {
        return m("div", {
          className: "EmojiPicker-body EmojiPicker-empty"
        }, m("p", null, "A\xFAn no has usado emojis recientemente."));
      }
      return m("div", {
        className: "EmojiPicker-body EmojiPicker-grid EmojiPicker-grid--standard"
      }, this.recentEmojis.map(item => {
        if (item.type === 'custom') {
          return m("button", {
            className: "EmojiPicker-item EmojiPicker-item--custom",
            type: "button",
            title: ":".concat(item.value, ":"),
            "data-emoji": item.value,
            "aria-label": item.label,
            onmouseenter: () => {
              this.hoveredLabel = item.label;
            },
            onmouseleave: () => {
              this.hoveredLabel = '';
            },
            onclick: e => {
              e.stopPropagation();
              this.insert('custom', item.value, item.label);
            }
          }, m("img", {
            src: "".concat(baseUrl, "/api/custom-emojis/").concat(item.value),
            alt: item.label,
            className: "EmojiPicker-img"
          }));
        }
        return m("button", {
          className: "EmojiPicker-item EmojiPicker-item--standard",
          type: "button",
          title: item.label,
          onmouseenter: () => {
            this.hoveredLabel = item.label;
          },
          onmouseleave: () => {
            this.hoveredLabel = '';
          },
          onclick: e => {
            e.stopPropagation();
            this.insert('standard', item.value, item.label);
          }
        }, m("span", {
          className: "EmojiPicker-char"
        }, item.value));
      }));
    }

    // Categoría estándar
    const category = STANDARD_EMOJI_CATEGORIES.find(c => c.id === this.activeTab);
    if (!category) return null;
    return m("div", {
      className: "EmojiPicker-body EmojiPicker-grid EmojiPicker-grid--standard"
    }, category.emojis.map(emoji => m("button", {
      className: "EmojiPicker-item EmojiPicker-item--standard",
      type: "button",
      title: emoji.name,
      onmouseenter: () => {
        this.hoveredLabel = "".concat(emoji.char, " ").concat(emoji.name);
      },
      onmouseleave: () => {
        this.hoveredLabel = '';
      },
      onclick: e => {
        e.stopPropagation();
        this.insert('standard', emoji.char, emoji.name);
      }
    }, m("span", {
      className: "EmojiPicker-char"
    }, emoji.char))));
  }
  renderSearchResults(filtered, baseUrl) {
    const customList = filtered.customList,
      standardList = filtered.standardList;
    if (customList.length === 0 && standardList.length === 0) {
      return m("div", {
        className: "EmojiPicker-body EmojiPicker-empty"
      }, m("i", {
        className: "fas fa-search",
        style: "font-size: 24px; opacity: 0.4; margin-bottom: 8px; display: block;"
      }), m("p", null, "No se encontraron emojis para \"", this.searchQuery, "\""));
    }
    return m("div", {
      className: "EmojiPicker-body EmojiPicker-searchGroup"
    }, customList.length > 0 && m("div", {
      className: "EmojiPicker-section"
    }, m("div", {
      className: "EmojiPicker-sectionTitle"
    }, "\uD83E\uDD81 Stickers Athletic Club (", customList.length, ")"), m("div", {
      className: "EmojiPicker-grid EmojiPicker-grid--custom"
    }, customList.map(item => m("button", {
      className: "EmojiPicker-item EmojiPicker-item--custom",
      type: "button",
      title: ":".concat(item.name, ":"),
      "data-emoji": item.name,
      "aria-label": item.label,
      onmouseenter: () => {
        this.hoveredLabel = item.label;
      },
      onmouseleave: () => {
        this.hoveredLabel = '';
      },
      onclick: e => {
        e.stopPropagation();
        this.insert('custom', item.name, item.label);
      }
    }, m("img", {
      src: "".concat(baseUrl, "/api/custom-emojis/").concat(item.name),
      alt: item.label,
      className: "EmojiPicker-img"
    }))))), standardList.length > 0 && m("div", {
      className: "EmojiPicker-section"
    }, m("div", {
      className: "EmojiPicker-sectionTitle"
    }, "\uD83D\uDE00 Emojis Est\xE1ndar (", standardList.length, ")"), m("div", {
      className: "EmojiPicker-grid EmojiPicker-grid--standard"
    }, standardList.map(emoji => m("button", {
      className: "EmojiPicker-item EmojiPicker-item--standard",
      type: "button",
      title: emoji.name,
      onmouseenter: () => {
        this.hoveredLabel = "".concat(emoji.char, " ").concat(emoji.name);
      },
      onmouseleave: () => {
        this.hoveredLabel = '';
      },
      onclick: e => {
        e.stopPropagation();
        this.insert('standard', emoji.char, emoji.name);
      }
    }, m("span", {
      className: "EmojiPicker-char"
    }, emoji.char))))));
  }
  getFilteredEmojis(customNames) {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) return null;
    const customList = [];
    const standardList = [];

    // Búsqueda en custom emojis
    for (const name of customNames) {
      const meta = CUSTOM_EMOJI_METADATA[name] || {
        label: name.replace(/^ee-/, '').replace(/-/g, ' '),
        keywords: []
      };
      const matchName = name.toLowerCase().includes(query);
      const matchLabel = meta.label.toLowerCase().includes(query);
      const matchKeywords = meta.keywords && meta.keywords.some(k => k.toLowerCase().includes(query));
      if (matchName || matchLabel || matchKeywords) {
        customList.push({
          name,
          label: meta.label
        });
      }
    }

    // Búsqueda en emojis estándar (todas las categorías)
    for (const cat of STANDARD_EMOJI_CATEGORIES) {
      for (const emoji of cat.emojis) {
        const matchName = emoji.name.toLowerCase().includes(query);
        const matchKeywords = emoji.keywords.some(k => k.toLowerCase().includes(query));
        const matchChar = emoji.char === query;
        if (matchName || matchKeywords || matchChar) {
          if (!standardList.some(e => e.char === emoji.char)) {
            standardList.push(emoji);
          }
        }
      }
    }
    return {
      customList,
      standardList
    };
  }
  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.hoveredLabel = '';
      this.closeHandler = e => {
        const el = this.element;
        if (el && !el.contains(e.target)) {
          this.isOpen = false;
          document.removeEventListener('click', this.closeHandler, true);
          this.closeHandler = null;
          m.redraw();
        }
      };
      setTimeout(() => {
        var _this$element;
        document.addEventListener('click', this.closeHandler, true);
        // Enfocar input de búsqueda al abrir
        const input = (_this$element = this.element) == null ? void 0 : _this$element.querySelector('.EmojiPicker-searchInput');
        if (input) {
          input.focus();
        }
      }, 50);
    } else {
      if (this.closeHandler) {
        document.removeEventListener('click', this.closeHandler, true);
        this.closeHandler = null;
      }
    }
    m.redraw();
  }
  onremove() {
    if (this.closeHandler) {
      document.removeEventListener('click', this.closeHandler, true);
      this.closeHandler = null;
    }
  }
  insert(type, value, label) {
    this.saveRecent({
      type,
      value,
      label
    });
    this.isOpen = false;
    if (this.closeHandler) {
      document.removeEventListener('click', this.closeHandler, true);
      this.closeHandler = null;
    }
    const textToInsert = type === 'custom' ? "[customemoji=".concat(value, "]") : value;
    if (this.attrs.textEditor && typeof this.attrs.textEditor.insertAtCursor === 'function') {
      this.attrs.textEditor.insertAtCursor(textToInsert);
    } else if (app.composer && app.composer.editor && typeof app.composer.editor.insertAtCursor === 'function') {
      app.composer.editor.insertAtCursor(textToInsert);
    }
    setTimeout(() => {
      if (this.attrs.textEditor && typeof this.attrs.textEditor.focus === 'function') {
        this.attrs.textEditor.focus();
      } else if (app.composer && app.composer.editor && typeof app.composer.editor.focus === 'function') {
        app.composer.editor.focus();
      }
    }, 50);
    m.redraw();
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/custom-emojis/EmojiPicker', EmojiPicker);